module.exports = __webpack_public_path__ + "img/santos-small.6771f98b.svg";